import Router from "@/src/components/router";

export default function Index() {
  return (
    <Router
      routes={[
        { text: "Header", componentUrl: "/components/header" },
        { text: "TabBar", componentUrl: "/components/tab-bar" },
      ]}
    />
  );
}
